import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const webhookEventStatusSchema = z.enum(["success", "failed", "pending"]);

const webhookEventSchema = z.object({
  _id: zExt.objectId(),
  status: webhookEventStatusSchema,
  attempts: z.number(),
  payload: z.record(z.string(), z.any()),
  payloadHash: z.string().optional(),
  pendingAt: z.date().optional(),
  webhook: zExt.objectId(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type WebhookEventOutput = z.infer<typeof webhookEventSchema>;

export const getWebhookEvents = {
  name: "getWebhookEvents" as const,
  input: z.object({
    webhookId: z.string(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
    returnId: z.string().optional(),
  }),
  output: z.object({
    events: z.array(webhookEventSchema),
    total: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
};
